/*
  Laboo desktop mega menu behaviour (30 Sep 2026).
  Hover and keyboard focus open the panel through CSS (see laboo-nav.css). This file only:
  - positions the fixed full-width panel directly under the visible header
  - closes the open panel on Escape (focus returns to the trigger)
  - makes the first tap on a touch laptop open the panel instead of navigating
*/
(function () {
  'use strict';
  if (window.__labooMegaReady) return;
  window.__labooMegaReady = true;

  var DESKTOP = window.matchMedia('(min-width: 1025px)');
  var openItem = null;
  var lastPointerType = 'mouse';
  var suppressFocus = false;

  function panelOf(item) { return item.querySelector(':scope > .laboo-mega__panel'); }
  function triggerOf(item) { return item.querySelector(':scope > [data-laboo-mega-trigger]'); }

  function place(item) {
    var panel = panelOf(item);
    if (!panel || !DESKTOP.matches) return;
    var bar = item.closest('.header__top') || item.closest('.sticky-header, main-header') || document.getElementById('site-header');
    var bottom = bar ? Math.round(bar.getBoundingClientRect().bottom) : 131;
    var cw = document.documentElement.clientWidth;
    var width = Math.min(1360, cw - 80);
    // 17 Oct 2026 (Claude): line the panel up with the header's own content edges (logo/nav to icons),
    // so on wide screens it no longer floats centred and looks shifted right of the menu.
    var row = bar && bar.classList.contains('header__top') ? bar.getBoundingClientRect() : null;
    var alignLeft = null;
    // Tony 17 Oct: panel runs FULL WIDTH edge to edge; its content stays lined up with the header edges.
    var inner = panel.querySelector(':scope > .laboo-mega__inner');
    if (row && row.width > 600) {
      width = cw; alignLeft = 0;
      if (inner) { var firstLink = bar.querySelector('.site-nav .link-list > li > a, .site-nav .link-list > li > [data-laboo-mega-trigger]'); var startX = firstLink ? Math.round(firstLink.getBoundingClientRect().left) : Math.round(row.left); inner.style.boxSizing = 'border-box'; inner.style.paddingLeft = '0px'; inner.style.paddingRight = '0px'; inner.style.marginLeft = startX + 'px'; inner.style.width = (Math.round(row.right) - startX) + 'px'; inner.style.maxWidth = 'none'; }
    } else if (inner) { inner.style.marginLeft = ''; inner.style.width = ''; inner.style.paddingLeft = ''; inner.style.paddingRight = ''; }
    panel.style.width = width + 'px';
    panel.style.top = '0px';
    panel.style.left = '0px';
    // the panel is position:fixed; measure where "0,0" really is (handles transformed ancestors)
    var origin = panel.getBoundingClientRect();
    panel.style.top = (bottom - origin.top) + 'px';
    panel.style.left = ((alignLeft !== null ? alignLeft : Math.round((cw - width) / 2)) - origin.left) + 'px';
    panel.style.maxHeight = Math.max(240, window.innerHeight - bottom - 8) + 'px';
  }

  function setExpanded(item, state) {
    var t = triggerOf(item);
    if (t) t.setAttribute('aria-expanded', state ? 'true' : 'false');
  }

  function markOpen(item) {
    if (openItem && openItem !== item) closeItem(openItem, false);
    openItem = item;
    item.classList.remove('is-dismissed');
    place(item);
    setExpanded(item, true);
  }

  function closeItem(item, dismiss) {
    item.classList.remove('is-open');
    if (dismiss) item.classList.add('is-dismissed');
    setExpanded(item, false);
    if (openItem === item) openItem = null;
  }

  function init(item) {
    if (item.dataset.labooMegaReady) return;
    item.dataset.labooMegaReady = 'true';
    var trigger = triggerOf(item);

    item.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch') return;
      markOpen(item);
    });
    item.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'touch') return;
      // keep an Escape dismissal while keyboard focus is still inside; otherwise re-arm hover
      if (!item.contains(document.activeElement)) item.classList.remove('is-dismissed');
      if (!item.matches(':has(:focus-visible)')) {
        setExpanded(item, false);
        if (openItem === item) openItem = null;
      }
    });
    item.addEventListener('focusin', function (e) {
      if (suppressFocus) return;
      if (e.target.matches && e.target.matches(':focus-visible')) markOpen(item);
    });
    item.addEventListener('focusout', function () {
      setTimeout(function () {
        if (!item.contains(document.activeElement)) {
          item.classList.remove('is-dismissed');
          if (!item.matches(':hover')) { item.classList.remove('is-open'); setExpanded(item, false); if (openItem === item) openItem = null; }
        }
      }, 0);
    });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && (item.matches(':hover') || item.contains(document.activeElement))) {
        closeItem(item, true);
        if (item.contains(document.activeElement) && trigger) {
          suppressFocus = true;
          trigger.focus({ preventScroll: true });
          suppressFocus = false;
        }
        e.stopPropagation();
      } else if (e.key === 'ArrowDown' && e.target === trigger) {
        var first = item.querySelector('.laboo-mega__panel a');
        if (first) { e.preventDefault(); markOpen(item); first.focus(); }
      }
    });
    if (trigger) {
      trigger.addEventListener('pointerdown', function (e) { lastPointerType = e.pointerType; });
      trigger.addEventListener('click', function (e) {
        if (lastPointerType === 'touch' && DESKTOP.matches && !item.classList.contains('is-open')) {
          e.preventDefault();
          item.classList.add('is-open');
          markOpen(item);
        }
      });
    }
  }


  /* Mobile drawer: keep Tab / Shift+Tab inside the open drawer (the theme also marks the page inert). */
  function initDrawerTrap() {
    var drawer = document.getElementById('site-menu-sidebar');
    if (!drawer || drawer.dataset.labooTrap) return;
    drawer.dataset.labooTrap = 'true';
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var nodes = drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), summary');
      var items = Array.prototype.filter.call(nodes, function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }


  /* 30 Day Guarantee modal: role=dialog, focus on open / restore on close, Esc, backdrop, close button, scroll lock. */
  (function () {
    var modal = null;
    var dialog = null;
    var opener = null;
    var prevBodyOverflow = '';

    function ensure() {
      if (!modal) modal = document.querySelector('[data-laboo-guarantee]');
      if (modal && modal.parentNode !== document.body) document.body.appendChild(modal);
      if (modal && !dialog) dialog = modal.querySelector('[role="dialog"]');
      return !!modal;
    }
    function isOpen() { return !!modal && !modal.hidden; }
    function open(from) {
      if (!ensure()) return;
      opener = from || null;
      prevBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      document.documentElement.classList.add('laboo-guarantee-open');
      modal.hidden = false;
      dialog.focus();
    }
    function close() {
      if (!isOpen()) return;
      modal.hidden = true;
      document.body.style.overflow = prevBodyOverflow;
      document.documentElement.classList.remove('laboo-guarantee-open');
      var target = opener;
      opener = null;
      if (target && target.isConnected) {
        target.focus({ preventScroll: true });
        if (document.activeElement !== target) {
          var menu = target.closest('.laboo-mega');
          var trigger = menu && menu.querySelector('[data-laboo-mega-trigger]');
          if (trigger) trigger.focus({ preventScroll: true });
        }
      }
    }

    document.addEventListener('click', function (e) {
      var o = e.target.closest && e.target.closest('[data-laboo-guarantee-open]');
      if (o) { e.preventDefault(); e.stopPropagation(); open(o); return; }
      if (isOpen() && e.target.closest('[data-laboo-guarantee-close]')) close();
    }, true);

    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopImmediatePropagation();
        close();
      } else if (e.key === 'Tab') {
        var items = Array.prototype.filter.call(dialog.querySelectorAll('a[href], button:not([disabled])'), function (el) { return el.offsetParent !== null; });
        if (!items.length) { e.preventDefault(); dialog.focus(); return; }
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }, true);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ensure);
    else ensure();
  })();

  function initAll() { document.querySelectorAll('[data-laboo-mega]').forEach(init); initDrawerTrap(); }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openItem) closeItem(openItem, true);
  });
  document.addEventListener('click', function (e) {
    if (openItem && !openItem.contains(e.target)) closeItem(openItem, false);
  });
  window.addEventListener('scroll', function () { if (openItem) place(openItem); }, { passive: true });
  window.addEventListener('resize', function () { if (openItem) place(openItem); }, { passive: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
